export default __webpack_public_path__ + "static/media/avatar_8.ec6ebc4b.svg";